import { trackingEvent } from '@notino/web-tracking';

import { dispatchEcommerceMessage } from '@services/messagingService';

import { EcommerceSectionNamespace } from '../../model';

export const trackFormSubmitFailed = (errorMessages: string, formName: string, formElement: string) => {
  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.FORM_SUBMIT_FAILED,
      form: {
        name: formElement,
        type: formName,
        interaction: EcommerceSectionNamespace.EEcommerceInteraction.BUTTON,
        error_message: errorMessages,
        action: EcommerceSectionNamespace.EEcommerceAction.FORM_SUBMIT_FAILED,
      },
      _clear: true,
    }),
  );
};
